<template>
  <div class="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
body {
  background: linear-gradient(75deg, #EB0006 0%, #000000 33.33%, #000000 66.67%, #EE0FC9 100%) no-repeat center center fixed;
  margin: 0;
  font-family: 'Fira Sans';
}

p {
  margin: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
